module.exports = __webpack_public_path__ + "img/3.ed3fc553.jpg";